export const state = () => ({
  account: {},
})

export const getters = {
  account(state) {
    return state.account
  }
}

export const mutations = {
  SET_ACCOUNT(state, account) {
    state.account = account
  },

  CLEAR_ACCOUNT(state) {
    state.account = {}
  }
}
